import { symbols, WILD, SCATTER } from "../configs/symbols.config.js";

const SYMBOL_NAMES = symbols
    .filter((s) => s.name !== WILD && s.name !== SCATTER)
    .map((s) => s.name);

function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomBool() {
    return Math.random() >= 0.5;
}

function shuffle(arr) {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
        const j = randomInt(0, i);
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

export class DummyServer {
    constructor() {
        this._isWin = false;
    }

    post(url, params) {
        switch (url) {
            case "/slot/spin": return this._spin(params);
            default: return null;
        }
    }

    _spin(params) {
        this._isWin = !this._isWin;
        const spin = this._isWin ? this._generateWinnerSpin() : this._generateLoserSpin();

        const win = this._isWin ? Math.random() * 10 : 0;

        const result = {
            status: "success",
            spin,
            bet: params.bet,
            multi: 0,
            win: win.toFixed(2),
            after_balance: params.balance + win,
            before_balance: params.balance,
            action: "betwin",
        };

        return { data: result };
    }
    _generateLoserSpin() {
        const result = [[], [], []];
        const pool = shuffle(SYMBOL_NAMES);

        const reels = [];
        for (let i = 0; i < 4; i++) {
            const a = pool[i % pool.length];
            const b = pool[(i + 1) % pool.length];
            reels.push([0, 1, 2].map(() => randomBool() ? a : b));
        }
        reels.push([
            reels[1][randomInt(0, 2)],
            reels[2][randomInt(0, 2)],
            reels[3][randomInt(0, 2)],
        ]);

        for (let i = 0; i < 3; i++) {
            for (let j = 0; j < 5; j++) {
                result[i].push(reels[j][i]);
            }
        }
        return result;
    }

    _generateWinnerSpin() {
        const result = [[], [], []];
        const names = SYMBOL_NAMES;

        for (let i = 0; i < 3; i++) {
            for (let j = 0; j < 5; j++) {
                result[i].push(names[randomInt(0, names.length - 1)]);
            }
        }

        // Force a win on middle row
        const winSymbol = names[randomInt(0, names.length - 1)];
        const winLength = randomInt(3, 5);
        for (let j = 0; j < winLength; j++) {
            result[1][j] = winSymbol;
        }

        return result;
    }

}
